export interface EmployeeRoot {
  '@odata.context': string;
  value: Employee[];
}

export interface Employee {
  '@odata.etag': string;
  id: string;
  number: string;
  displayName: string;
  givenName: string;
  middleName: string;
  surname: string;
  jobTitle: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
  phoneNumber: string;
  mobilePhone: string;
  email: string;
  personalEmail: string;
  employmentDate: string;
  terminationDate: string;
  status: string;
  birthDate: string;
  statisticsGroupCode: string;
  lastModifiedDateTime: string;
}

export class EmployeeDomain {
  employees: Employee[] = [];

  constructor(employees: Employee[]) {
    this.employees = employees;
  }
}
